import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { RevenueBySourceStoreEffects } from './revenue.effects';
import { dashboardRevenueBySourceStoreFeatureKey, reducer } from './revenue.reducers';

export function provideRevenueBySourceStore(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideState(dashboardRevenueBySourceStoreFeatureKey, reducer),
    provideEffects([RevenueBySourceStoreEffects]),
  ]);
}
